<template>
  <v-container style="max-width: 1000px;">
    <v-card
    >
      <v-form
        class="ma-6"
        ref="form" 
      >
        <v-combobox
          prefix="TO"
          v-model="emailModel.toList"
          @change="updateEmailList($event, 'to')"
          :rules="[required]"
          chips
          clearable
          multiple
          dense
          hide-details="auto"
          append-icon=""
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              color="secondary"
              @click="select"
              @click:close="removeToList(item, 'to')"
            >
              {{ item }}
            </v-chip>
          </template>
        </v-combobox>
        <v-combobox
          prefix="CC"
          v-model="emailModel.ccList"
          @change="updateEmailList($event, 'cc')"
          chips
          clearable
          multiple
          dense
          hide-details="auto"
          append-icon=""
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              color="secondary"
              @click="select"
              @click:close="remove(item, 'cc')"
            >
              {{ item }}
            </v-chip>
          </template>
        </v-combobox>
        <v-combobox
          prefix="BCC"
          v-model="emailModel.bccList"
          @change="updateEmailList($event, 'bcc')"
          chips
          clearable
          multiple
          dense
          hide-details="auto"
          append-icon=""
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              color="secondary"
              @click="select"
              @click:close="remove(item, 'bcc')"
            >
              {{ item }}
            </v-chip>
          </template>
        </v-combobox>
        <v-text-field
          prefix="Title"
          v-model="emailModel.title"
          :rules="[required]"
          hide-details="auto"
        ></v-text-field>
        <quill-editor 
          v-model="emailModel.body"
          class="editor my-2"
          ref="quillEditorA"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @ready="onEditorReady($event)">
        </quill-editor>
        <div class="text-right">
          <v-btn 
            type="button"
            elevation="0"
            color="secondary"
            @click="submitEmail"
            :loading="submitting"
          >
            Send
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-container>
</template>

<style scoped>
  .editor {
      height: 40rem;
      overflow: hidden;
    }
</style>

<script>
import axios from "axios";
import { rules } from "@/mixins";

export default {
  name: "Editor",
  data(){
      return {
        submitting: false,
        emailModel: {
          taskId: null, // U/W Task
          toList: null,
          ccList: null,
          bccList: null,
          attachments: null,
          title: null,
          body: null,
        },
        editorOption: {
            modules: {
              toolbar: [
                  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons

                  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                  [{ 'list': 'ordered'}, { 'list': 'bullet' }],

                  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                ]
            },
            theme: 'snow',
        }
      }
  },
  methods: {
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      console.log('editor ready!', quill)
    },
    updateEmailList(email, type){
      const isEmailFormat = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);

      if(!isEmailFormat){
        this.removeToList(email, type);
      }
    },
    removeToList(item, type){
      if(type === 'to'){
        this.emailModel.toList.splice(this.emailModel.toList.indexOf(item), 1);
        this.emailModel.toList = [...this.emailModel.toList];
      }
      else if(type === 'cc'){
        this.emailModel.ccList.splice(this.emailModel.ccList.indexOf(item), 1);
        this.emailModel.ccList = [...this.emailModel.ccList];
      }
      else if(type === 'bcc'){
        this.emailModel.bccList.splice(this.emailModel.bccList.indexOf(item), 1);
        this.emailModel.bccList = [...this.emailModel.bccList];
      }
    },
    async postEmail(request){
      const resp = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/Feature/Notification/SendEmail`, 
              request,
              {
                headers: {
                  Authorization: `Bearer ${this.$store.state.token}`,
                },
              });

      return resp;
    },
    async submitEmail(){
      if (this.$refs.form.validate()) {
        this.submitting = true;
        const res = await this.postEmail(this.emailModel).catch(err => err.response);

        if(res.status === 200){
          alert("sucess");
        }
        else {
          alert("error: " + res.data);
        }

        this.submitting = false;
      }
    }
  },
  // computed: {
  //   editorA() {
  //     return this.$refs.quillEditorA.quill
  //   },
  //   editorB() {
  //     return this.$refs.quillEditorB.quill
  //   }
  // },
  mixins: [rules]
}
</script>